export enum NegotiationCaseQueryField {
  // ---------- NEGOTIATION CASE ----------
  negotiationCaseNumber = 'negotiationCaseNumber',
  negotiationTotalSum = 'negotiationTotalSum',
  negotiationStatus = 'negotiationStatus',
  negotiationUpdatedAt = 'negotiationUpdatedAt',
  negotiationCreatedAt = 'negotiationCreatedAt',
  purchaseRequisitionExternalId = 'purchaseRequisitionExternalId',
  // ---------- SUPPLIER ----------
  supplierName = 'supplierName',
  supplierExternalId = 'supplierExternalId',
  // ---------- SUPPLIER CONTACT ----------
  supplierContactLastName = 'supplierContactLastName',
  supplierContactFirstName = 'supplierContactFirstName',
  supplierContactEmail = 'supplierContactEmail',
  // ---------- ISSUES ----------
  openIssueCount = 'openIssueCount',
  resolvedIssueCount = 'resolvedIssueCount',
  totalIssueCount = 'totalIssueCount',

  responsible = 'responsible',
}

export enum NegotiationCaseQueryFieldGroup {
  negotiation = 'negotiation',
  purchaseRequisition = 'purchaseRequisition',
  supplier = 'supplier',
  supplierContact = 'supplierContact',
  other = 'other',
  discount = 'discount',
  issues = 'issues',
}
